import { render, staticRenderFns } from "./PropertySideBarUnitItemTest.vue?vue&type=template&id=4ecf234b&scoped=true&"
import script from "./PropertySideBarUnitItemTest.vue?vue&type=script&lang=js&"
export * from "./PropertySideBarUnitItemTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf234b",
  null
  
)

export default component.exports